

export default function getDateForInputFromMysqlDate(mysqlDateString){
    if(!mysqlDateString || mysqlDateString.length <=0)
        return "";

    const date = new Date(mysqlDateString);
    const year = date.getFullYear();
    const month = (date.getMonth()+1) < 10 ? "0"+(date.getMonth()+1) : (date.getMonth()+1);
    const day = date.getDate() < 10 ? "0"+date.getDate() : date.getDate();

    return `${year}-${month}-${day}`;
}

export function getUserInitials(user){
    let parts = user.name.split(" ");
    let initials = [];

    parts.forEach(part=>{
        if(part.length > 0)
            initials.push(part.charAt(0));
    })

    return initials.join("").toUpperCase();
}